import { render, staticRenderFns } from "./tatUpload.vue?vue&type=template&id=1d8adde0"
import script from "./tatUpload.vue?vue&type=script&lang=js"
export * from "./tatUpload.vue?vue&type=script&lang=js"
import style0 from "./tatUpload.vue?vue&type=style&index=0&id=1d8adde0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports